import React from 'react';
import {Link} from 'react-router-dom';
import styles from '../styles/components/Footer.module.css';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.links}>
          <Link to="/" className={styles.link}>Home</Link>
          <Link to="/ranking" className={styles.link}>Weekly Ranking</Link>
          <Link to="/ranking-global" className={styles.link}>Global Ranking</Link>
          <a href="mailto:support@arithmeticblitz.com" className={styles.link}>Contact</a>
        </div>
        <div className={styles.copyright}>&copy; {new Date().getFullYear()} Arithmetic Blitz. All rights reserved.</div>
      </div>
    </footer>
  );
};

export default Footer;

